import { z } from 'zod'
import { Instant } from './primitives'

export const META_APP_ID_PATTERN = /^\d{5,32}$/
export const META_APP_SECRET_PATTERN = /^[0-9a-fA-F]{32}$/

export const MetaAppUpdateRequest = z.strictObject({
  appId: z.string().trim().regex(META_APP_ID_PATTERN),
  appSecret: z.string().trim().regex(META_APP_SECRET_PATTERN),
  confirmDisconnect: z.boolean().default(false),
})
export type MetaAppUpdateRequest = z.infer<typeof MetaAppUpdateRequest>

export const MetaAppSettings = z.object({
  appId: z.string().min(1),
  secretUpdatedAt: Instant,
  webhookUrl: z.url(),
  verifyToken: z.string().min(1),
  oauthRedirectUri: z.url(),
  verifyTokenReissued: z.boolean(),
})
export type MetaAppSettings = z.infer<typeof MetaAppSettings>
